import type { ButtonProps } from '@chakra-ui/react';
import { Button, Image, Text } from '@chakra-ui/react';
import type { WalletConfig } from '@cronos-app/wallet';
import type { FC } from 'react';

type WalletCardProps = {
  walletConfig: WalletConfig;
  onClick: () => void;
} & ButtonProps;

export const WalletCard: FC<WalletCardProps> = ({
  walletConfig: { name, icon, title },
  ...rest
}) => {
  return (
    <Button
      variant="secondary"
      key={name}
      borderColor="text.secondary"
      color="text.secondary"
      justifyContent="flex-start"
      gap="8px"
      {...rest}
    >
      <Image src={icon} boxSize="24px" alt={title} />
      <Text>{title}</Text>
    </Button>
  );
};
